import React, { useState } from "react";
import { InputAdornment, OutlinedInput, Popover, TextField } from "@material-ui/core";
import { ClearOutlined, SearchOutlined } from "@material-ui/icons";
import Flag from "react-world-flags";
import "./InputWithFlag.scss";
import { IconChevronDown } from "@tabler/icons";
import IconButton from "@mui/material/IconButton";



export const InputWithFlag = ({ companyInfoSearch, handleChangeInput, searchCompany, handleClearClick, flagSelected, setFlagSelected, errors, countries, ...props }) => {

    const [anchorEl, setAnchorEl] = useState(null);
    const [open, setOpen] = useState(false);
    const [searchCode, setSearchCode] = useState("");


    const handleClickFlag = (e) => {
        setAnchorEl(e.currentTarget)
        setOpen(!open);
    }

    const handleClose = () => {
        setOpen(false);
    }

    const handleChangeFlag = (code) => {
        setFlagSelected(code);
        setOpen(false);
    }

    const handleChangeSearchCountry = event => {
        const value = event.target.value;
        setSearchCode(value);
    }


    return (
        <div className="input-flag d-flex">
            <div className="flag-combo">
                <div className="d-flex flag-selector" onClick={handleClickFlag}>
                    <Flag code={flagSelected} className="flag" aria-describedby="id-desplegable" />
                    <IconChevronDown className="arrow" />
                </div>
                <Popover
                    id="id-desplegable"
                    className="flag-list-modal"
                    open={open}
                    anchorEl={anchorEl}
                    onClose={handleClose}
                    anchorOrigin={{
                        vertical: 'bottom',
                        horizontal: 'left',
                    }}
                >
                    <TextField value={searchCode} onChange={handleChangeSearchCountry} className="search-country" />
                    <ul className="flag-list-modal">
                        {countries.filter((c) => c.countryCommonLabel.toLowerCase().includes(searchCode.toLowerCase())).map((c) => {
                            return (
                                <li key={c.code} onClick={() => handleChangeFlag(c.countryCode)}>
                                    <div className="d-flex">
                                        <Flag className="flag" code={c.countryCode} />
                                        <span className="flag-label">{c.countryCommonLabel}</span>
                                    </div>
                                </li>
                            )
                        })}
                    </ul>
                </Popover>
            </div>
            <div className="input-identification w-100">
                <div className="search-input">

                    <form key="fc" variant="outlined" className="search-input-control"  onSubmit={companyInfoSearch ? searchCompany : undefined}>
                        <OutlinedInput
                            className="input-search"
                            id="outlined-adornment-password"
                            key="oi"
                            value={companyInfoSearch}
                            onChange={handleChangeInput}
                            placeholder="Identificador o nombre de la empresa"
                            type="text"
                            error={errors['companyInfoSearch'] != null}
                            endAdornment={
                                <InputAdornment position="end" >
                                    <IconButton onClick={handleClearClick}>
                                        {companyInfoSearch ? <ClearOutlined /> : ''}
                                    </IconButton>
                                    <SearchOutlined
                                        key="dd"
                                        aria-label="toggle password visibility"
                                        edge="end"
                                        onClick={companyInfoSearch ? searchCompany : undefined}
                                        className="search-icon"
                                    /> 
                                </InputAdornment>
                            }
                        />
                    </form>
                </div>
            </div>
        </div>
    );
}                        